import { render, staticRenderFns } from "./pedidoFloat.vue?vue&type=template&id=f26941ce&scoped=true&"
import script from "./pedidoFloat.vue?vue&type=script&lang=js&"
export * from "./pedidoFloat.vue?vue&type=script&lang=js&"
import style0 from "./pedidoFloat.vue?vue&type=style&index=0&id=f26941ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26941ce",
  null
  
)

export default component.exports